// extracted by mini-css-extract-plugin
module.exports = {"link":"GoogleForm_link__n6yYG","padded":"GoogleForm_padded__DPx_q"};